import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";
import LocalizationManager from "Engine/base/localization/LocalizationManager";
import MoneyFormat from "Base/MoneyFormat";

export default class BaseSymbolsPaysContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
        this.addListeners();
    }

    init() {
        this.infoText = this.getChildByName('info_text_13');
        this.symbosPays = this.getChildrenByLibName('paytable/info/symbolPaysContainer');
        this.onBetChanged();
    }

    addListeners() {
        GlobalDispatcher.add('model:betChanged', this.onBetChanged, this);
    }

    onBetChanged(event) {
        this.infoText.text = LocalizationManager.getLocalizedText('info_text_13', [MoneyFormat.format(EntryPoint.GameModel.bet, false)]);
        this.symbosPays.forEach((item)=>{
            item.setValue(EntryPoint.GameModel.bet);
        });
    }

    destroy(options) {
        GlobalDispatcher.remove('model:betChanged', this.onBetChanged, this);
        super.destroy(options);
    }
}